import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useManyRefs } from '@carnica/utils/hooks';
import { useEffect, useMemo, useRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import styles from "../../TabBarMenu/styles.pcss";
var cnTabBarMenu = cnBem('tabbar-menu', styles);
export var useMenuNavigation = function useMenuNavigation(_ref) {
  var items = _ref.items,
    closeMenu = _ref.closeMenu,
    getMenuAttributes = _ref.getMenuAttributes,
    getMenuRef = _ref.getMenuRef,
    getMenuDisabled = _ref.getMenuDisabled,
    getMenuKey = _ref.getMenuKey,
    isOpen = _ref.isOpen;
  var buttonRef = useRef(null);
  var itemRefs = useManyRefs(items.length || 0);
  var indexes = useMemo(function () {
    var keys = items.map(getMenuKey);
    return items.filter(function (item) {
      return !getMenuDisabled(item);
    }).map(function (item) {
      return keys.indexOf(getMenuKey(item));
    });
  }, [items]);
  var getItemAttributes = function getItemAttributes(item) {
    var attributes = getMenuAttributes(item) || {};
    var index = items.indexOf(item);
    var onKeyDown = function onKeyDown(e) {
      var _attributes$onKeyDown;
      (_attributes$onKeyDown = attributes.onKeyDown) === null || _attributes$onKeyDown === void 0 ? void 0 : _attributes$onKeyDown.call(attributes, e);
      if (e.code === 'Tab' && !e.shiftKey && !indexes.find(function (el) {
        return el > index;
      })) {
        var _buttonRef$current;
        closeMenu();
        (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.focus();
      }
    };
    return _objectSpread(_objectSpread({}, attributes), {}, {
      onKeyDown: onKeyDown,
      className: cnTabBarMenu('item', [attributes.className])
    });
  };
  var getItemRef = function getItemRef(item) {
    var index = items.indexOf(item);
    return combineRefs([itemRefs[index], getMenuRef(item)]);
  };
  useEffect(function () {
    if (isOpen) {
      setTimeout(function () {
        var _itemRefs$0$current;
        return (_itemRefs$0$current = itemRefs[0].current) === null || _itemRefs$0$current === void 0 ? void 0 : _itemRefs$0$current.focus();
      }, 300);
    }
  }, [isOpen]);
  return useMemo(function () {
    return {
      getItemAttributes: getItemAttributes,
      getItemRef: getItemRef,
      buttonRef: buttonRef
    };
  }, [items, getItemAttributes]);
};